<template>
  <div class="mx-3">
    <v-layout row wrap class="mt-4 py-2 justify-space-between">
      <v-flex xs12 md8>
      <v-toolbar flat class="custom-toolbar" color="white">
        <v-toolbar-title>Anticipos de Sueldo</v-toolbar-title>
      </v-toolbar>
      
      <div class="justify-text">
        <div>
          Porque en Grupo Security nos preocupamos por ti y tus finanzas, te ofrecemos la
          oportunidad de recibir un anticipo de hasta el 40% de tu sueldo líquido. Este adelanto te
          permite acceder a un monto de tu remuneración antes de la fecha de pago regular.
        </div>
        <div class="mt-2">Puedes solicitarlo una sola vez, o de forma permanente. Solo debes hacerlo antes del día 5
          de cada mes ya que, de manera contraria, el anticipo se aplicará al mes siguiente.
        </div>
        <div class="mt-2">Es una forma conveniente de manejar tus necesidades financieras y asegurarte de tener los
          recursos necesarios cuando más los necesitas.
        </div>
        <div class="mt-2">¡No esperes más y aprovecha este beneficio!</div>
      </div>
      </v-flex>
    </v-layout>

    <v-toolbar flat color="white">
      <v-toolbar-title>Mi Historial</v-toolbar-title>
    </v-toolbar>

    <v-data-table v-if="advance_payments && advance_payments.length > 0" :headers="headers" :items="advance_payments" class="elevation-1" key="advance-payment-table"  rows-per-page-text="Filas por página" no-data-text="Sin resultados">
      <template v-slot:items="props">
        <tr :key="props.item.id">
          <td>{{ props.item.created_at }}</td>
          <td>{{ props.item.advance_payment_type }}</td>
          <td :class="getStatusClass(props.item.status)"><b>{{ props.item.status }}</b></td>
          <td >
            <v-chip outline small class="d-flex justify-space-between align-center" style="border: none">
              <span>{{ props.item.hidden ? '*******' : '$' +  props.item.amount }}</span>
              <v-btn small flat icon @click="toggleShowAmount(props.item)">
                <template v-if="props.item.hidden">
                  <v-icon translate="no">visibility</v-icon>
                </template>
                <template v-else>
                  <v-icon translate="no">visibility_off</v-icon>
                </template>
              </v-btn>
            </v-chip>
          </td>
          <td v-if="props.item.approved === 'Si'">
            <v-icon medium color="success" small translate="no">check</v-icon>
          </td>
          <td v-else-if="props.item.approved === 'No'">
            <v-icon medium color="error" small translate="no"> close</v-icon>
          </td>
          <td v-else>
            <v-icon medium color="warning" small translate="no">more_horiz</v-icon>
          </td>
          <td v-if="props.item.advance_payment_type === 'Permanente' || props.item.approved === 'No'">-</td>
          <td v-else>{{ props.item.period }}</td>
          <td>
            <v-dialog v-model="dialogComments[props.index]" max-width="500px" :key="props.item.id" ref="dialogRef">
              <template v-slot:activator="{ on }">
                <v-btn flat
                    :disabled="!props.item.comment"
                    :color="props.item.comment ? 'primary' : 'normal'"
                    :class="props.item.comment ? 'border-bottom' : ''"
                    small
                    style="text-transform: none;"
                    v-on="on"> Ver comentario
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <h2>Comentario</h2>
                </v-card-title>
  
                <v-card-text>
                  <template>
                    {{ props.item.comment }}
                  </template>
                </v-card-text>
  
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat  @click="closeDialogComment(props.index)">Cerrar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
          <!-- <td v-if="props.item.edited">
             <v-btn color="warning" style="text-transform: none;" flat @click="editAdvancePayment(props.item)">Editar</v-btn>
          </td> -->
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"></v-btn>
      </template>
    </v-data-table>
    <div v-else>
      <h3 class="my-4">Por el momento, no hay registros de anticipos históricos.</h3>
    </div>
    <h3>* Se consideran anticipos a partir de Septiembre 2023</h3>
    <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" style=" float: right;" dark class="mb-2 ml-auto" v-on="on">Solicitar nuevo Anticipo</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <h2>{{ formTitle }}</h2>
          </v-card-title>

          <v-card-text>
            <AdvancePaymentsForm :current_period="current_period" :advance_payment="advance_payment" @submitForm="submitForm" ref="childForm" />
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="submitForm" :disabled="isButtonDisabled">{{ updateOrCreate }}</v-btn>
            <v-btn color="info" flat @click="close">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from "sweetalert2"
import AdvancePaymentsForm from './AdvancePaymentsForm.vue';
export default {
  
  props: {
    advance_payments: {
      type: Array,
      required: false,
    },
    current_period: {
      type: String,
      required: true,
    },
  },

  components: {
    AdvancePaymentsForm
  },

  data() {
    return {
      showModal: false,
      dialog: false,
      headers: [
        { text: 'Fecha de Solicitud', sortable: false, value: 'created_at' },
        { text: 'Tipo', sortable: false, value: 'advance_payment_type' },
        { text: 'Condición', sortable: false,  value: 'status' },
        { text: 'Monto', sortable: false,  value: 'amount' },
        { text: 'Estado', sortable: false,  value: 'status' },
        { text: 'Periodo de pago', sortable: false,  value: 'period' },
        { text: 'Comentario', sortable: false, value: 'comment' },
        // { text: '', sortable: false, value: 'update' }
      ],
      editedIndex: -1,
      advance_payment: {amount: '0', type: 'permanent', id: null},
      modalOpen: false,
      dialogComments: [],
      isButtonDisabled: false
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Solicitar Anticipo' : 'Edit Item';
    },
    isCommentEmpty(item) {
      return !item;
    },
    updateOrCreate(){
      if (this.advance_payment.id){
        return 'Actualizar Anticipo'
      }else{
        return 'Crear Anticipo'
      }
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
  },

  methods: {
    ...mapActions("advance_payments", ["createAdvancePayment", "updateAdvancePayment"]),
    async submitForm() {
      this.isButtonDisabled = true;
      setTimeout(() => {
        this.isButtonDisabled = false;
      }, 5000);

      const advance_payment = this.$refs.childForm.setFormData();
      const res = this.advance_payment.id ? await this.updateAdvancePayment(advance_payment) : await this.createAdvancePayment(advance_payment);
      this.handleResponse(res);
    },

    handleResponse(res) {
      this.dialog = false;
      if (res.success) {
        if (res.message === "Advance payment created" || res.message === "Advance payment updated") {
          this.$emit("advance_payment_added", res.advance_payment);
          const swalAlert = this.swalAlert(res.message === "Advance payment created");
          setTimeout(() => {
            swalAlert.close();
          }, 3000);
        } else if (res.message === "Exists") {
          this.swalAlertErrorExists();
        } else {
          this.swalAlertError();
        }
      }else {
        this.swalAlertError();
      }
    },
    swalAlert(isCreated) {
      const title = isCreated ? "Solicitud de Anticipo Enviada" : "Solicitud de Anticipo Actualizada";
      return Swal.fire({
        title: title,
        text: "Te confirmaremos por correo cuando tu solicitud de anticipo esté aprobada",
        icon: "success"
      });
    },

    swalAlertErrorExists() {
      Swal.fire({
        title: "Ya tienes un anticipo en curso",
        icon: "error",
        customClass: {
          confirmButton: "primary"
        }
      });
    },

    swalAlertError() {
      Swal.fire({
        title: "Error",
        text: "Ha ocurrido un error al crear la solicitud",
        icon: "error"
      });
    },

    getStatusClass(status) {
      switch (status) {
        case "Rechazado":
          return "red--text";
        case "PENDIENTE":
          return "primary--text";
        case "Aprobado":
          return "success--text";
        default:
          return "";
      }
    },

    close() {
      this.dialog = false;
      this.advance_payment.id = null;
      this.advance_payment.amount = "0";
      this.advance_payment.type = "permanent";
      setTimeout(() => {
      }, 300);
    },

    closeDialogComment(index) {
      this.$set(this.dialogComments, index, false);
    },

    toggleShowAmount(item) {
      item.hidden = !item.hidden;
    },

    editAdvancePayment(item) {
      this.advance_payment.id = item.id;
      this.advance_payment.amount = item.amount.replace(/\./g, "");
      this.advance_payment.type = item.advance_payment_type === "Única Vez" ? "once" : "permanent";
      this.dialog = true;
    }
  }};
</script>
<style>
.justify-text{
  text-align: justify;
}
@media screen and (max-width: 960px) {
  .card-size-m {
    max-width: 300px; 
    margin: 0 auto;
  }
}
.border-bottom{
  border-bottom: 1px solid !important;
}
.custom-toolbar .v-toolbar__content {
  padding: 0;
}
</style>